import axios from 'axios'
import { getCsrfToken } from '@/services/csrf'

import { getApiBaseUrl } from '@/config/apiBase'

const baseURL = getApiBaseUrl()

/** Resposta 204 = visitante sem refresh cookie/token (estado normal na tela de login). */
export function isAuthRefreshNoSession(status: number): boolean {
  return status === 204
}

/** POST /auth/refresh com headers exigidos pelo CSRF da API */
export async function postAuthRefresh() {
  const csrf = await getCsrfToken()
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  }
  if (csrf) headers['X-CSRF-Token'] = csrf

  return axios.post(
    `${baseURL}/auth/refresh`,
    {},
    { headers, withCredentials: true, timeout: 10_000 },
  )
}
